<template>
    <router-view />
</template>

<style>
/* @import "./style/popup.css"; */
@import url("https://fonts.googleapis.com/css2?family=Electrolize&family=Orbitron&display=swap");
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: black;
    height: 100vh;
    width: 100%;
    /* cursor: url("./assets/cursor.png"), auto; do przemyslenia */
}
</style>
